import { Box, IconSize } from '@bechtel/gds';
import { FC } from 'react';
import { useTheme } from 'styled-components';
import { SpinnerIconStyled } from './styled';

export interface AppSpinnerProps {
  size?: IconSize;
  fillColor?: string;
}

export const AppSpinner: FC<AppSpinnerProps> = ({ size, fillColor }) => {
  const theme = useTheme();
  return (
    <Box>
      <SpinnerIconStyled
        icon="spinner"
        fillColor={fillColor ? fillColor : theme.colors.primary['500']}
        size={size ? size : IconSize.SMALL}
      ></SpinnerIconStyled>
    </Box>
  );
};
